import {SideReelFeature} from "./SideReelFeature";

export class BlankFeature extends SideReelFeature {
    constructor(rowId: number, whichSide: string, featureName: string) {
        super(rowId, whichSide, featureName);
    }
}